import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrypto = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 8,
		fill: "#EFB914"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.3388 5.15006C10.3732 5.17918 10.4078 5.20882 10.4413 5.23919C11.1377 5.8712 11.5886 6.73041 11.7142 7.66498L10.3012 7.28636C10.1224 6.92026 9.98483 6.66969 9.52642 6.25377C9.06809 5.83794 8.47755 5.59855 7.85946 5.57762C7.24121 5.55678 6.63461 5.75601 6.14775 6.14008C5.66094 6.52413 5.32447 7.06817 5.19829 7.67618C5.07215 8.28422 5.16475 8.91699 5.45866 9.46265C5.75263 10.0083 6.22973 10.4323 6.80537 10.6586C7.38087 10.8847 8.01805 10.8994 8.60405 10.6997C9.19022 10.5 9.45185 10.1746 9.81197 9.90826L11.1731 10.273C10.6859 11.0808 9.9304 11.6908 9.0397 11.9943C8.88528 12.0469 8.72814 12.0881 8.56995 12.1212L8.16353 13.638L6.875 13.2927L7.17754 12.1636C6.95831 12.1312 6.74169 12.0793 6.52916 12.0101L6.23167 13.1204L4.94314 12.7751L5.32025 11.3677C4.88732 11.0306 4.52423 10.606 4.25971 10.115C3.81312 9.28594 3.67319 8.32462 3.86476 7.40076C4.05646 6.47673 4.56753 5.64928 5.30735 5.06565C5.83995 4.64553 6.46647 4.37096 7.12617 4.26194L7.53841 2.72344L8.826 3.06845L8.50222 4.2768C8.72169 4.31778 8.93695 4.37638 9.14547 4.4532L9.49478 3.14958L10.7824 3.49459L10.3388 5.15006Z",
		fill: "white"
	})]
});
export default SvgCrypto;
